import { AuthShellTone, AuthStatusView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useAuthLogo } from '@/auth/useAuthLogo'
import { AUTH_NAMESPACE } from '@/i18n'

/** Shown when the account is pending activation (TO-361 login-surface REQ-007). */
export function AccountInactivePage() {
	const { t } = useTranslation(AUTH_NAMESPACE)
	const logo = useAuthLogo()

	return (
		<AuthStatusView
			logo={logo}
			tone={AuthShellTone.Warning}
			title={t('inactive.title')}
			message={t('inactive.message')}
			action={{ label: t('status.backToLogin'), href: '/login' }}
		/>
	)
}
